"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgActionWatch = props => (0, jsx_runtime_1.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  children: [(0, jsx_runtime_1.jsx)("path", {
    fill: "currentColor",
    d: "M12.5 8c-1.65 0-3.25.48-4.61 1.4a7.99 7.99 0 0 0-2.75 3.1 7.96 7.96 0 0 0 2.8 3.14A8.32 8.32 0 0 0 12.5 17c1.03 0 2.03-.19 3-.56a8.12 8.12 0 0 0 4.36-3.94 7.99 7.99 0 0 0-2.75-3.1A8.3 8.3 0 0 0 12.5 8m0-1.5a9.68 9.68 0 0 1 9 6 9.74 9.74 0 0 1-18 0 9.67 9.67 0 0 1 9-6z"
  }), (0, jsx_runtime_1.jsx)("path", {
    stroke: "currentColor",
    fill: "transparent",
    d: "M12.44 10.5a2 2 0 1 0 2 2 2 2 0 0 0-2-2z",
    strokeWidth: "1.5"
  })]
});
exports.default = SvgActionWatch;